//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FfBreadcbItem',
  props: {
    to: {},
    replace: Boolean,
    showsep: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      separator: '',
      separatorClass: '',
      linkflag :true
    };
  },

  inject: ['elBreadcrumb'],

  mounted() {
    this.separator = this.elBreadcrumb.separator;
    this.separatorClass = this.elBreadcrumb.separatorClass;
    const link = this.$refs.link;
    link.setAttribute('role', 'link');
    link.addEventListener('click', _ => {
      const { to, $router } = this;
      if (!to || !$router) return;
      this.replace ? $router.replace(to) : $router.push(to);
    });
  },
  created(){
    //门户过来则隐藏菜单信息
      let portalflag = this.$route.query.portalflag;
      let openflag = this.$route.query.openflag;
      if(portalflag == 'portal' || openflag == 'portal'){

        this.linkflag = false;
      }
  }
};



// WEBPACK FOOTER //
// ./src/pccomponents/FfBreadcbItem.vue